export default __webpack_public_path__ + "static/media/Navamani Logo 1.42e5be12.jpg";